import logger from "redux-logger";

export const FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION =
  "FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION";
export const FETCH_CHEMISTPAYMENTDETAILS_SUCCESS_ACTION =
  FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTPAYMENTDETAILS_FAIL_ACTION =
  FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION =
  "FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION";
export const FETCH_CHEMISTPAYMENTSTATUSCHANGE_SUCCESS_ACTION =
  FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTPAYMENTSTATUSCHANGE_FAIL_ACTION =
  FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION + "_ERROR";
  
export const FILTER_BY_CHEMISTPAYMENT_STATUS_INIT_ACTION =
  "FILTER_BY_CHEMISTPAYMENT_STATUS_INIT_ACTION";
export const FILTER_BY_CHEMISTPAYMENT_STATUS_SUCCESS_ACTION =
  FILTER_BY_CHEMISTPAYMENT_STATUS_INIT_ACTION + "_SUCCESS";
export const FILTER_BY_CHEMISTPAYMENT_STATUS_FAIL_ACTION =
  FILTER_BY_CHEMISTPAYMENT_STATUS_INIT_ACTION + "_ERROR";

export function ChemistPaymentList(value) {
  return {
    type: FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION,
    value:value
  };
}
export function ChemistPaymentSelectedPage(value) {
  return {
    type: FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION,
    value: value
  };
}
export function ChemistPaymentStatusChange(value) {
  return {
    type: FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION,
    value: value
  };
}